//
import ProductModel from '../../../models/Warehouse/WhProduct'
import Service from '@/services/api/service'

//
export default class extends Service {
    //
    static appends = [
        'sale_prices',
        'stocks',
        'sale_price_by_branch_office',
        'branch_offices',
    ]

    //
    static includes = ['wh_product_upc_code']

    //
    static model = ProductModel

    /**
     *
     */
}
